import ImageElementEleve from '../VueEvalNat/BilanEval/FormBilanEval/FormQuestion/Elements/ImageElementEleve';
import ExpressionNumeriqueElementEleve from '../VueEvalNat/BilanEval/FormBilanEval/FormQuestion/Elements/ExpressionNumeriqueElementEleve';
import NumberLineElementEleve from '../VueEvalNat/BilanEval/FormBilanEval/FormQuestion/Elements/NumberLineElementEleve';
import ZoomableMedia from './ZoomableMedia';
import MathText from './MathText';

/**
 * Rendu d'un choix QCM — string ou objet élément { type, config }
 * Réutilisable dans QuestionForm (aperçu), la projection, Quiz, ResultatsQCM, etc.
 *
 * @param {string|Object} choix - Le choix brut (string ou { type, config })
 * @param {string} className - Classes CSS additionnelles pour le texte
 */
const ChoixRenderer = ({ choix, className = 'text-sm text-slate-200', compact = false, light = false }) => {
  if (!choix) return null;

  // String simple → texte (ou KaTeX si délimiteurs $...$)
  if (typeof choix === 'string') {
    return <MathText className={className}>{choix}</MathText>;
  }

  // Objet élément { type, config }
  const { type, config } = choix;
  if (!type || !config) return null;

  switch (type) {
    case 'expression':
      return light
        ? <span className="text-gray-800 [&_.katex]:text-gray-800 [&_p]:text-gray-800"><ExpressionNumeriqueElementEleve config={config} theme="light" /></span>
        : <ExpressionNumeriqueElementEleve config={config} theme="dark" />;
    case 'image':
      return <ImageElementEleve config={compact ? { ...config, maxWidth: 'compact' } : config} theme={light ? 'light' : 'dark'} />;
    case 'numberline':
      return <NumberLineElementEleve config={config} theme={light ? 'light' : 'dark'} />;
    case 'geogebra':
      if (config.ggb_svg) {
        return (
          <ZoomableMedia
            type="svg"
            content={config.ggb_svg}
            className="bg-white rounded-lg overflow-hidden w-fit max-w-full [&_svg]:block [&_svg]:max-w-full [&_svg]:h-auto [&_svg]:max-h-[150px] sm:[&_svg]:max-h-[200px]"
          />
        );
      }
      if (config.ggb_image) {
        return (
          <ZoomableMedia
            type="image"
            src={`data:image/png;base64,${config.ggb_image}`}
            alt="Figure GeoGebra"
            className="max-w-full h-auto rounded-lg bg-white"
          />
        );
      }
      return <span className={className}>Figure GeoGebra</span>;
    default:
      return null;
  }
};

export default ChoixRenderer;
